import React, { useEffect, useState } from "react";
import { Alert, Modal, Button, Spinner, Row, Col, Form } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { saveWorkFlowEmp } from "../../redux/on&offBoarning/Mantenimientos/WorkFlowEmp/actions";
import { getResponsables } from "../../redux/climalaboral/campaña/action";
import { getWorkflows } from "../../redux/on&offBoarning/workflow/actions";
import { getUnlinkCategories } from "../../redux/Modulo_Sanciones/Unlink_Categories/actions";
import { workflowAssign } from "../../redux/Modulo_Sanciones/Casualty_Monitor/actions";

const WorkflowCreator = (props) => {
  //*States
  const [respSelected, setRespSelected] = useState([]);
  const [tempSelected, setTempSelected] = useState([]);
  // const [catSelected, setCatSelected] = useState([]);
  const [validated, setValidated] = useState(false);
  const [isRespValid, setIsRespValid] = useState(false);
  const [isTempValid, setIsTempValid] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  // const [isCategoryValid, setIsCategoryValid] = useState(false);
  //*Redux
  const { saveLoading, formError } = useSelector(
    (store) => store.casualtyMonitor
  );
  const { error } = useSelector((store) => store.wflowempleados);
  const saveLoadingWorkFlow = useSelector(
    (store) => store.wflowempleados.saveLoading
  );
  const { responsable, responsableLoading } = useSelector(
    (store) => store.campaña
  );
  const { loading, workflows } = useSelector((store) => store.workflow);
  const workflowError = useSelector((store) => store.workflow.error);
  const { unlinkCategories, unlinkCategoriesError } = useSelector(
    (store) => store.unlinkCategories
  );
  const loadingUnlinkCategories = useSelector(
    (store) => store.unlinkCategories.loading
  );
  //*variables
  const dispatch = useDispatch();

  let templateOptions = [];
  workflows &&
    workflows.map((template) => {
      if (parseInt(template.tipo_workflow) === 2) {
        templateOptions = [
          ...templateOptions,
          {
            id: template.id,
            label: `${template.nombre}`,
          },
        ];
      }
    });
  let responsableOptions = [];
  responsable &&
    responsable.map((user) => {
      responsableOptions = [
        ...responsableOptions,
        {
          id: user.id,
          label: `${user.username}-${user.first_name} ${user.last_name}`,
        },
      ];
    });
  // let categoryOptions = [];
  // unlinkCategories &&
  //   unlinkCategories.map((categ) => {
  //     categoryOptions = [
  //       ...categoryOptions,
  //       {
  //         id: categ.id,
  //         label: `${categ.nombre}`,
  //       },
  //     ];
  //   });
  //* Methods
  useEffect(() => {
    dispatch(getResponsables({ rol_responsable: "Responsable_OffBoarding" }));
    dispatch(getWorkflows({}));
    dispatch(getUnlinkCategories({}));
  }, []);

  const SaveWorkflowAssign = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }
    if (respSelected.length === 0) {
      setIsRespValid(true);
    } else {
      setIsRespValid(false);
    }
    if (tempSelected.length === 0) {
      setIsTempValid(true);
    } else {
      setIsTempValid(false);
    }
    // if (catSelected.length === 0) {
    //   setIsCategoryValid(true);
    // } else {
    //   setIsCategoryValid(false);
    // }
    setIsSubmit(true);
    if (
      respSelected.length === 0 ||
      tempSelected.length === 0
      // ||
      // catSelected.length === 0
    ) {
      return;
    }

    // const req = {
    //   categoria_desvinculacion: catSelected[0].id,
    // };
    const reqWF = {
      empleados: [
        {
          empleado: parseInt(props.editItem.usuario_id),
          responsable: respSelected[0].id,
        },
      ],
      workflow: tempSelected[0].id,
    };

    // dispatch(saveWorkFlowEmp(req.empleado, setRespSelected));
    try {
      dispatch(
        workflowAssign(
          reqWF,
          () => setRespSelected([]),
          () => setTempSelected([]),
          () => setIsSubmit(false),
          props.handleClose
        )
      );
      // setCatSelected([]);
    } catch (ex) {
      console.log(ex.response);
    }
  };

  return (
    <Modal
      size="md"
      show={props.show}
      onHide={() => {
        props.handleClose(false);
        setRespSelected([]);
        // setCatSelected([]);
        setTempSelected([]);
        setIsRespValid(false);
        setIsTempValid(false);
        // setIsCategoryValid(false);
        setIsSubmit(false);
      }}
    >
      <Form onSubmit={SaveWorkflowAssign} noValidate validated={validated}>
        <Modal.Header closeButton>
          <Modal.Title className="text-muted">
            Desvinculación {props.editItem.nombre}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* {formError === "" &&
            workflowError === "" &&
            unlinkCategoriesError === "" &&
            error === "" && (
              <Row
                className="mb-2 mx-0 py-2 bg-light rounded"
                style={{ borderLeft: "6px solid #141E30 " }}
              >
                <Col>
                  <p>
                    <b className="text-muted">
                      Al asignar un workflow, el empleado pasará al proceso
                      correspondiente a OffBoarding.
                    </b>
                  </p>
                </Col>
              </Row>
            )} */}
          {!!formError && (
            <Alert variant="danger" className="mt-4 mb-1">
              {formError}
            </Alert>
          )}
          {!!error && (
            <Alert variant="danger" className="mt-4 mb-1">
              {error}
            </Alert>
          )}
          {!!workflowError && (
            <Alert variant="danger" className="mt-4 mb-1">
              {workflowError}
            </Alert>
          )}
          {!!unlinkCategoriesError && (
            <Alert variant="danger" className="mt-4 mb-1">
              {unlinkCategoriesError}
            </Alert>
          )}
          {props.editItem && !props.editItem.usuario_id && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              No se puede crear workflow porque el empleado no tiene un usuario
              creado.
            </Alert>
          )}
          <Form.Group as={Col} className="mb-1">
            <Form.Label
              column
              sm="12"
              md="12"
              className={
                isTempValid && isSubmit
                  ? `text-danger`
                  : !isTempValid && tempSelected.length !== 0 && isSubmit
                  ? `text-success`
                  : `text-muted`
              }
            >
              Plantilla de workflow
            </Form.Label>
            <Typeahead
              isInvalid={isTempValid && isSubmit}
              isValid={!isTempValid && tempSelected.length !== 0 && isSubmit}
              placeholder="Seleccione una plantilla de workflow"
              disabled={props.editItem && !props.editItem.usuario_id}
              options={templateOptions}
              onChange={(selected) => {
                setTempSelected(selected);
                if (isSubmit) {
                  if (selected.length === 0) {
                    setIsTempValid(true);
                  } else {
                    setIsTempValid(false);
                  }
                }
              }}
              selected={tempSelected}
            ></Typeahead>
            {loading && (
              <Col sm={1}>
                <Spinner animation="border" size="sm" />
              </Col>
            )}
            {isTempValid && (
              <div>
                <small className="text-danger">**Campo requerido</small>
              </div>
            )}
          </Form.Group>
          <Form.Group as={Col} className="mb-1">
            <Form.Label
              column
              sm="12"
              md="12"
              className={
                isRespValid && isSubmit
                  ? `text-danger`
                  : !isRespValid && respSelected.length !== 0 && isSubmit
                  ? `text-success`
                  : `text-muted`
              }
            >
              Responsable de OffBoarding
            </Form.Label>
            <Typeahead
              isInvalid={isRespValid && isSubmit}
              isValid={!isRespValid && respSelected.length !== 0 && isSubmit}
              placeholder="Seleccione un responsable de offboarding"
              disabled={props.editItem && !props.editItem.usuario_id}
              options={responsableOptions}
              onChange={(selected) => {
                setRespSelected(selected);
                if (isSubmit) {
                  if (selected.length === 0) {
                    setIsRespValid(true);
                  } else {
                    setIsRespValid(false);
                  }
                }
              }}
              selected={respSelected}
            ></Typeahead>
            {responsableLoading && (
              <Col sm={1}>
                <Spinner animation="border" size="sm" />
              </Col>
            )}
            {isRespValid && (
              <div>
                <small className="text-danger">**Campo requerido</small>
              </div>
            )}
          </Form.Group>
          {/* <Form.Group as={Col} className="mb-1">
            <Form.Label
              column
              sm="12"
              md="12"
              className={
                isCategoryValid && isSubmit
                  ? `text-danger`
                  : !isCategoryValid && catSelected.length !== 0 && isSubmit
                  ? `text-success`
                  : `text-muted`
              }
            >
              Categoria de desvinculación
            </Form.Label>
            <Typeahead
              isInvalid={isCategoryValid && isSubmit}
              isValid={!isCategoryValid && catSelected.length !== 0 && isSubmit}
              placeholder="Seleccione una categoria de desvinculación"
              options={categoryOptions}
              onChange={(selected) => {
                setCatSelected(selected);
                if (isSubmit) {
                  if (selected.length === 0) {
                    setIsCategoryValid(true);
                  } else {
                    setIsCategoryValid(false);
                  }
                }
              }}
              selected={catSelected}
            ></Typeahead>
            {loadingUnlinkCategories && (
              <Col sm={1}>
                <Spinner animation="border" size="sm" />
              </Col>
            )}
            {isCategoryValid && (
              <div>
                <small className="text-danger">**Campo requerido</small>
              </div>
            )}
          </Form.Group> */}
        </Modal.Body>
        <Modal.Footer>
          <Button className="rounded-pill" variant="secondary" onClick={()=>props.handleClose(false)}>
            Cancelar
          </Button>
          <Button
            disabled={saveLoading || saveLoadingWorkFlow}
            className="rounded-pill"
            variant="primary"
            type="submit"
          >
            {saveLoading || saveLoadingWorkFlow ? (
              <Spinner
                className="mr-2"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : null}
            Crear WorkFlow
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default withRouter(WorkflowCreator);
